






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class AppLayer extends Vue {
  @Prop() readonly layer!: any;

  public get config() {
    return {
      ...this.layer.config,
      listening: this.layer.config.draggable
    };
  }
}
